var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"ds-badge",class:_vm.variant},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }